import type { ReactNode } from "react"
import { QueryClientProvider } from "@tanstack/react-query"

import { BrandProvider } from "@/components/layout/brand-provider"
import { ThemeProvider } from "@/components/theme-provider"
import { Toaster } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import { queryClient } from "@/lib/query-client"

/**
 * App-wide providers, mounted once in `routes/__root.tsx` above every
 * page. The shared `queryClient` lives at module scope in
 * `lib/query-client.ts` so the same cache backs both these hooks and
 * the router's `loader`/`beforeLoad` prefetches.
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system">
        {/* Branding is the first request and must resolve before auth. */}
        <BrandProvider>
          <TooltipProvider>
            {children}
            <Toaster />
          </TooltipProvider>
        </BrandProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
